module.exports = __webpack_public_path__ + "img/bf-red.cf31feb7.png";